export class ImageStyle {
    rotate: number
    scaleX: number
    scaleY: number
}

export enum Direction {
    DEFAULT = 0,
    VERTICAL = 1,
    HORIZONTAL = 2,
}


// WEBPACK FOOTER //
// ./src/models/image.style.ts